import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/layout';
import { MainSection } from '@/components/layout/MainSection';
import { ProfileAvatar, ProfileInfo, UserEditForm } from '@/widgets';
import { useAccountContext } from '@/layouts/AccountLayout/context';

const EditTab: React.FC = () => {
  const { t } = useTranslation(['account']);
  const {
    user,
    handleAvatarChange,
    handleAvatarRemove,
    profileInfoItems,
    setShowEditForm,
    isMobile,
  } = useAccountContext();

  // On mobile: show ProfileAvatar + ProfileInfo in swiper slide
  // (UserEditForm is rendered via mobileOverlay in AccountLayout when showEditForm=true)
  if (isMobile) {
    return (
      <MainSection title={t('account:editProfile')}>
        <ProfileAvatar
          name={`${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'User'}
          location={undefined}
          avatarUrl={user?.avatar_url}
          onAvatarChange={handleAvatarChange}
          onAvatarRemove={handleAvatarRemove}
          onEditClick={() => setShowEditForm(true)}
        />
        <ProfileInfo items={profileInfoItems} />
      </MainSection>
    );
  }

  // On desktop: UserEditForm is always visible in main content
  return (
    <MainSection title={t('account:editProfile')}>
      <Card>
        <UserEditForm />
      </Card>
    </MainSection>
  );
};

export default EditTab;
